import {Extension} from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    indent: {
      increaseIndent: () => ReturnType;
      decreaseIndent: () => ReturnType;
    };
  }
}

export const Indent = Extension.create({
  name: 'indent',

  addGlobalAttributes() {
    return [
      {
        types: ['paragraph', 'heading'],
        attributes: {
          indent: {
            default: 0,
            renderHTML: (attributes) => {
              if (!attributes.indent) {
                return {};
              }
              return {
                style: `margin-left: ${attributes.indent}px`,
              };
            },
            parseHTML: (element) => {
              const marginLeft = element.style.marginLeft;
              return marginLeft ? parseInt(marginLeft, 10) : 0;
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      increaseIndent:
        () =>
        ({commands, editor}) => {
          const currentIndent = editor.getAttributes('paragraph').indent || 0;

          return commands.updateAttributes('paragraph', {
            indent: currentIndent + 20,
          });
        },

      decreaseIndent:
        () =>
        ({commands, editor}) => {
          const currentIndent = editor.getAttributes('paragraph').indent || 0;

          return commands.updateAttributes('paragraph', {
            indent: Math.max(0, currentIndent - 20),
          });
        },
    };
  },
});
